<template>
  <div>
    <b-alert v-if="vuexServices.init == null" show variant="info">Aun no ha cotizado</b-alert>
    <b-alert v-if="vuexServices.init && vuexServices.quote.prices.length == 0" show variant="info">Servicios no disponibles</b-alert>
    <template v-if="vuexServices.quote.prices.length">
      <b-card v-for="(p, index) in vuexServices.quote.prices" no-body class="overflow-hidden mb-3" :key="index">
        <b-row no-gutters>
          <b-col md="4">
            <b-card-img :src="`https://www.feraltar.com/imghttps/${p.pic}`" alt="Image" class="rounded-0"></b-card-img>
          </b-col>
          <b-col md="8">
            <b-card-body>
              <h4 class="card-title">
                {{p.name}}
              </h4>
              <div class="row">
                <div class="col-md-7">
                  <b-card-text class="details-service" v-html="p.details"></b-card-text>
                </div>
                <div class="col-md-5 text-center">
                  <div class="p-2">
                    Vehiculos: 
                    <h4>{{ p.numVehicles }}</h4>
                  </div>
                  <div class="">
                    Total: 
                    <h3 class="text-success">{{getTotalService(p)}}</h3>
                  </div>
                  <div class="">
                    <b-button :href="urlBook(p)" variant="primary">Reservar</b-button>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </template>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faTaxi } from '@fortawesome/free-solid-svg-icons'
  export default {
    name:'ListServices',
    components:{FontAwesomeIcon},
    props:{
      services: {
        type: Array
      }
    },
    data() {
      return {
        icons:{
          faTaxi
        },
      }
    },
    methods:{
      getTotalService(service) {
        if (this.quoteRq.service == 'a' || this.quoteRq.service == 'd') {
          return service.totalOW
        }
        return service.totalRT
      },
      urlBook(service) {
        const baseUrl = `${process.env.MIX_APP_URL}${this.$prefixPanel}/book-service`
        let url = baseUrl + `?fromHotelId=${this.quoteRq.fromHotel.id}&toHotelId=${this.quoteRq.toHotel.id}&serviceType=${this.serviceType}&pax=${this.quoteRq.pax}&serviceId=${service.id}`
        return url
      }
    },
    computed:{
      serviceType() {
        if (this.quoteRq.service == 'a' || this.quoteRq.service == 'd'|| this.quoteRq.service == 'rt') {
          return 'service_airport'
        }
      },
      ...mapState({
        vuexServices: (state) => state.quote.quotation,
        quoteRq: (state) => state.quote.request,
      })
    }
  }
</script>